import { Component, Input, OnInit, Signal } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-choose-pass-type',
  standalone: false,
  templateUrl: './choose-pass-type.component.html',
  styleUrl: './choose-pass-type.component.css'
})
export class ChoosePassTypeComponent  implements OnInit {

  @Input('displayPassTypeDialog') displayPassTypeDialog: boolean = false;
  @Input({ required: true }) passTypesList!: Signal<any[]>;

  @Output() choosePassTypeEvent = new EventEmitter<string>();
  
  passTypeCols: any[] = [];
  selectedPassType!: string;

  constructor(
  ) { }

  ngOnInit(): void {
    // Define the columns for Brands grid
    this.passTypeCols = [
      { field: 'passType', header: 'Pass Type Name', display: 'table-cell', width:'30%'  },
    ]; 
  }

  ngOnChanges() {
  }

  // When the user chooses a Pass Type 
  onRowPassTypeSelect(event: any) {
    this.selectedPassType = event.data.passType;
  } 

  // When the user chooses a Pass Type
  onPassTypeSelect() {
    this.choosePassTypeEvent.emit(this.selectedPassType);
  }  

  // When the user cancels the dialog to select a PassType
  onCancelPassTypeSelect() {
    this.choosePassTypeEvent.emit();
  }


}
